import moment from 'moment';
import React, { useEffect, useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { IClientDocuments } from '../../../../../../../../redux/duck/legado/clientsApp/customersDocuments/interface/reduxApi';
import {
  getApiBalance,
  getClientDocuments,
  getDocumentsList,
  resetApiBalance,
} from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Button from '../../../../../../../../shared/components/buttons/Button';
import { defineAccountType } from '../../../../../../../../utils/businessRule';
import {
  accountIsClosed,
  accountIsInactive,
  accountTypeMask,
  capitalize,
  celMask,
  cpfCnpjMask,
} from '../../../../../../../../utils/masks';
import PdfPF from '../../../RegistrationForm/Button/components/PdfPF';
import PdfPJ from '../../../RegistrationForm/Button/components/PdfPJ';
import ExportPdfRegistration from '../../../RegistrationForm/Button/ExportPdf';
import { IBankInfoModal } from '../../interface';
import Info from './components/Info';
import Wrapper from './components/Wrapper';

function BankInfoModal(props: IBankInfoModal) {
  // Partner identificator: start
  const partnerListState = useSelector(
    (reducer: IReducer) => reducer.clientsApp.partnersList
  );
  function setPartner(id: any) {
    let partnerName = '';
    partnerListState.filter((partner) => {
      if (partner.id === id) {
        partnerName = partner.razao_social;
      }
      return partnerName;
    });
    return partnerName;
  }
  // Partner identificator: end

  function documents(e: any) {
    if (e && e.legalEntity === 'F') {
      return (
        <>
          {ExportPdfRegistration({
            title: 'Title',
            body: <PdfPF ctx={e} />,
          })}
        </>
      );
    }
    if (e && e.legalEntity === 'J') {
      return (
        <>
          {ExportPdfRegistration({
            title: 'Title',
            body: <PdfPJ ctx={e} />,
          })}
        </>
      );
    }
    return <></>;
  }

  // Documents: start
  const documentState = useSelector(
    (reducer: IReducer) => reducer.clientsDocuments
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      props.show === true ||
      props.data?.agency !== undefined ||
      props.data?.account !== undefined ||
      props.data?.digit !== undefined ||
      props.data?.cpfCnpj !== undefined
    ) {
      dispatch(
        getClientDocuments(
          props.data?.agency,
          props.data?.account,
          props.data?.digit,
          props.data?.cpfCnpj
        )
      );
    }
  }, [
    props.data?.account,
    props.data?.agency,
    props.data?.cpfCnpj,
    props.data?.digit,
  ]);
  // Documents: end

  // Documents: start
  const singleState = useSelector((reducer: IReducer) => reducer.clientSingle);

  useEffect(() => {
    dispatch(resetApiBalance());
    if (
      props.show === true ||
      props.data?.agency !== undefined ||
      props.data?.account !== undefined ||
      props.data?.digit !== undefined ||
      props.data?.cpfCnpj !== undefined
    ) {
      dispatch(
        getApiBalance(
          props.data?.agency,
          props.data?.account,
          props.data?.digit,
          props.data?.cpfCnpj
        )
      );
    }
  }, [
    props.data?.account,
    props.data?.agency,
    props.data?.cpfCnpj,
    props.data?.digit,
  ]);

  const defaultBalance = (e) => {
    if (e === null || e === undefined) {
      return 0;
    }
    return e;
  };

  const clientBalance = (e, y, c) => {
    return (
      <>
        <Wrapper.Info>
          <Info.Label>Saldo:</Info.Label>
          <Info.Value>
            {e.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Info.Value>
        </Wrapper.Info>
        <Wrapper.Info>
          <Info.Label>Débito:</Info.Label>
          <Info.Value>
            {y.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Info.Value>
        </Wrapper.Info>
        <Wrapper.Info>
          <Info.Label>Crédito:</Info.Label>
          <Info.Value>
            {c.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </Info.Value>
        </Wrapper.Info>
      </>
    );
  };

  // Get list of types of documents: start
  useEffect(() => {
    dispatch(getDocumentsList());
  }, []);

  function checkDocumentDescription(id: number) {
    let description: string = '';
    documentState.documents.filter((document) => {
      if (document.id === id) {
        description = document.documentDescription;
      }
      return description;
    });
    return description;
  }
  // Get list of types of documents: end

  const loading = useMemo(() => {
    if (
      documentState.isCustomerDocumentsLoading === true ||
      documentState.isDocumentsLoading === true
    ) {
      return (
        <Wrapper.Loading>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Loading>
      );
    }
    const value = documentState.clientDocuments.map(
      (document: IClientDocuments) => {
        const label = checkDocumentDescription(document.documentType);
        return (
          <Wrapper.Documents key={`${document.id}w`}>
            <Button.Default
              key={`${document.id}d`}
              onClick={() => window.open(document.documentLink, '_blank')}>
              Abrir
            </Button.Default>
            <Info.Label key={document.id}>{label}</Info.Label>
          </Wrapper.Documents>
        );
      }
    );
    return value;
  }, [documentState.isCustomerDocumentsLoading]);
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {`${capitalize(props.data?.companyName)} : ${setPartner(
            props.data?.partnerId
          )}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Base>
          <Info.Title>Dados Básicos</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Tipo:</Info.Label>
              <Info.Value>
                {accountTypeMask(props.data?.legalEntity)}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>CPF/CNPJ:</Info.Label>
              <Info.Value>{cpfCnpjMask(props.data?.cpfCnpj)}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Cel:</Info.Label>
              <Info.Value>{celMask(props.data?.cel)}</Info.Value>
            </Wrapper.Info>
            {props.data?.legalEntity === 'F' ? (
              <Wrapper.Info>
                <Info.Label>ID CBO:</Info.Label>
                <Info.Value>{props.data?.cbo}</Info.Value>
              </Wrapper.Info>
            ) : (
              <>
                <Wrapper.Info>
                  <Info.Label>ID CNAE:</Info.Label>
                  <Info.Value>{props.data?.cnae}</Info.Value>
                </Wrapper.Info>
                <Wrapper.Info>
                  <Info.Label>Fins Lucrativos:</Info.Label>
                  <Info.Value>
                    {props.data?.fins_lucrativo &&
                    props.data?.fins_lucrativo !== 0
                      ? 'Sim'
                      : 'Não'}
                  </Info.Value>
                </Wrapper.Info>
              </>
            )}
            <Wrapper.Info>
              <Info.Label>Gerar ficha cadastral:</Info.Label>
              <Info.Value>{documents(props.data)}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>E-mail:</Info.Label>
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 400 }}
                overlay={<Tooltip id="email">{props.data?.email}</Tooltip>}>
                <Info.Value>{props.data?.email}</Info.Value>
              </OverlayTrigger>
            </Wrapper.Info>
          </Wrapper.Row>
          <Info.Title>Bancário:</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Situação:</Info.Label>
              <Info.Value>
                {accountIsClosed(props.data?.closedAccount)}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Status:</Info.Label>
              <Info.Value>{accountIsInactive(props.data?.status)}</Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Tipo:</Info.Label>
              <Info.Value>
                {defineAccountType(props.data?.accountFormat)}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Agência:</Info.Label>
              <Info.Value>{props.data?.agency}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Conta:</Info.Label>
              <Info.Value>{props.data?.account}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Digito:</Info.Label>
              <Info.Value>{props.data?.digit}</Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>
          <Wrapper.Row>
            {clientBalance(
              defaultBalance(singleState.balance),
              defaultBalance(singleState.debit),
              defaultBalance(singleState.credit)
            )}
          </Wrapper.Row>
          <Info.Title>Tarifas:</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Mensal:</Info.Label>
              <Info.Value>
                {props.data?.monthlyFare.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>TED:</Info.Label>
              <Info.Value>
                {props.data?.tedFare.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Boleto:</Info.Label>
              <Info.Value>
                {props.data?.boletoFare.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}
              </Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>
          <Info.Title>Endereço:</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Rua:</Info.Label>
              <Info.Value>{props.data?.publicPlace}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>N°:</Info.Label>
              <Info.Value>{props.data?.number}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Bairro:</Info.Label>
              <Info.Value>{props.data?.district}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Complemento:</Info.Label>
              <Info.Value>{props.data?.complement}</Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Cidade:</Info.Label>
              <Info.Value>{props.data?.city}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>UF:</Info.Label>
              <Info.Value>{props.data?.country}</Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>CEP:</Info.Label>
              <Info.Value>{props.data?.cep}</Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>
          <Info.Title>Atualizações:</Info.Title>
          <Wrapper.Row>
            <Wrapper.Info>
              <Info.Label>Criado em:</Info.Label>
              <Info.Value>
                {moment(props.data?.createdAt).format('DD/MM/YYYY')}
              </Info.Value>
            </Wrapper.Info>
            <Wrapper.Info>
              <Info.Label>Atualizado em:</Info.Label>
              <Info.Value>
                {moment(props.data?.updatedAt).format('DD/MM/YYYY')}
              </Info.Value>
            </Wrapper.Info>
          </Wrapper.Row>

          <Info.Title>Documentos:</Info.Title>
          <Wrapper.List>{loading}</Wrapper.List>
        </Wrapper.Base>
      </Modal.Body>
      <Modal.Footer
        style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
        <Button.Default onClick={props.onHide}>Fechar</Button.Default>
      </Modal.Footer>
    </Modal>
  );
}
export default BankInfoModal;
